// extracted by mini-css-extract-plugin
export default {"labelClass":"AppInput_labelClass__GnFYK"};